import moment from "moment";

export default {
  provideImagePreviewURL: (images) => {
    let logoURL = [];
    images.forEach((file) => {
      logoURL.push(URL.createObjectURL(file));
    });
    return logoURL;
  },


  generateVideoThumbnail: (video, fileName) => {
  
    var canvas = document.createElement("canvas");
    canvas
      .getContext("2d")
      .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
   
    var dataURI = canvas.toDataURL("image/png",2);

    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    const myBlob = new Blob([ia], { type: mimeString });
    const name = fileName.split(".")[0] + ".png";
    console.log(name);
    var file = new File([myBlob], name, { type: myBlob.type });
    return file;
    
  },

  getFormatedSizeofVideoinMb: (bytes, decimals = 2) => {
    if (bytes === 0) return 0;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  },

  createVideoChunks: (file, chunkSize , endPointer) => {
    let startPointer = 0;
    let chunks = [];
    while (startPointer < endPointer) {
      let newStartPointer = startPointer + chunkSize;
      const chunk = file.slice(startPointer, newStartPointer, file.type);
      const f = new File([chunk], `${file.name}`, { type: chunk.type });
      chunks.push(file);
      startPointer = newStartPointer;
    }
    return chunks;
  },

  filterSentenceOrWord: (string, maxLength) => {
    return string.substr(0, maxLength) + "...";
  },

  getDateRange: (range = 0, type = "days") => {
    let date = new Date();

    if (range) {
      date = moment(date).subtract(range, type).calendar();
    } else {
      date = moment(date).format("YYYY-MM-DD");
    }
    switch (type) {
      case "days": {
        date = moment(date).format("YYYY-MM-DD");
        break;
      }
      case "months": {
        date = moment(date).format("YYYY-MM");
        break;
      }
      case "years": {
        date = moment(date).format("YYYY");
        break;
      }

      default:
        break;
    }

    console.log("method", date, range, type);
    return date.toString();
  },
  getDateTimeNow: () => {
    let date = new Date();
    console.log(date);
  },
  getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Months are zero-based, so we add 1
    const day = currentDate.getDate();
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  },
  getCurrentTime() {
    const currentDate = new Date();
    // Get the current time in Indian Standard Time (IST)
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    const formattedTime = currentDate.toLocaleString("en-IN", timeOptions);
    return formattedTime;
  },


generateClevertapUserEvent(name,id,mail){
    if (
      typeof window?.clevertap != undefined &&
      process.env.NEXT_PUBLIC_EVENTS_ISACTIVE != "false"
    ) {
      window?.clevertap?.onUserLogin.push({
        Site: {
          Name: name, // String
          Identity: id, // String or number
          Email: mail, // Phone (with the country code)
  
          // optional fields. controls whether the user will be sent email, push etc.
          "MSG-email": true, // Disable email notifications
          "MSG-push": true, // Enable push notifications
          "MSG-sms": true, // Enable sms notifications
          "MSG-whatsapp": true, // Enable WhatsApp notifications
        },
      });
      console.log("setUserUniqueAttributes sent", name, id, mail);
    }
  }
  
};
